import { RequirementConditionType } from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getAnalysisAutomationScore = (
  analysisAutomationItem: AutomationFormItem
): number => {
  const condition = analysisAutomationItem.requirementConditions.find(
    (condition) =>
      condition.type === RequirementConditionType.CandidateScoreCondition
  );
  return condition?.scoreScaled || 0;
};
